import { render, staticRenderFns } from "./OrganizationItem.vue?vue&type=template&id=13d4d980&scoped=true&"
import script from "./OrganizationItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationItem.vue?vue&type=style&index=0&id=13d4d980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4d980",
  null
  
)

export default component.exports